let session = { generation: 0, controller: new AbortController() };
const listeners = new Set<() => void>();

export class SessionChangedError extends Error {
  constructor() {
    super("Relace se změnila. Přihlaste se znovu.");
    this.name = "AbortError";
  }
}

export function getSession() {
  return session;
}

export function assertCurrentSession(expected: ReturnType<typeof getSession>) {
  if (expected !== session) throw new SessionChangedError();
}

export function startNewSession(publish?: () => void) {
  const previous = session;
  const next = { generation: previous.generation + 1, controller: new AbortController() };
  session = next;
  try {
    // Aborting requests and clearing caches can synchronously start new reads.
    // Those reads must see the new credentials, never the previous account.
    publish?.();
  } finally {
    previous.controller.abort();
    for (const listener of listeners) listener();
  }
  return next;
}

export function onSessionChange(listener: () => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
